import { createFileRoute } from '@tanstack/react-router'
import { UserAreaPage } from '@/components/UserAreaPage'
import { z } from 'zod'

const userAreaSearchSchema = z.object({
    highlight: z.string().optional(),
})

export const Route = createFileRoute('/user-area')({
    component: UserAreaPage,
    validateSearch: userAreaSearchSchema,
})
